import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, useTheme} from '@material-ui/core/styles';
import { formatDate } from '../../utils/Format';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { isNotEmpty } from '../../utils/Validator';
import { parseDate } from '../../utils/Utils';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

function desc(a, b, orderBy) {
    let c = a[orderBy];
    let d = b[orderBy];

    if (isNotEmpty(c)) {
        if (typeof c === "string") {
            c = c.toUpperCase();
        } else if (c instanceof Date) {
            c = parseDate(c);
        }
    } else {
        c = "";
    }

    if (isNotEmpty(d)) {
        if (typeof d === "string") {
            d = d.toUpperCase();
        } else if (d instanceof Date) {
            d = parseDate(d);
        }
    } else {
        d = "";
    }

    if (d < c) {
        return -1;
    }

    if (d > c) {
        return 1;
    }

    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'ftin', fid: 'ftin', numeric: false, disablePadding: true, label: 'Tax ID Number (TIN)', width: '40rem', filterLable:'Filter..'},
    { id: 'displayDate', fid: 'displayDate', numeric: false, disablePadding: true, label: 'Date Added', width: '45%', filterLable:'Filter..', },
    { id: 'selectAll', numeric: false, disablePadding: true, label: 'Remove', width: '20rem' },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, onRequestFilter } = props;
    
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    
    const onFilter = property => event => {
        onRequestFilter(event.target.value, property);
    };
   
    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <Grid container direction="column" style={{verticalAlign:'top'}}>
                            <Grid item>
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={order}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    <div className='Manage-users-tbl-hdr'>
                                        <div>
                                            {headCell.label}
                                            {orderBy === headCell.id ? (
                                                <span className={classes.visuallyHidden}>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </TableSortLabel>
                            </Grid>
                        </Grid>
                    </TableCell>
                ))}
            </TableRow>
            <TableRow className='filter-row' style={{borderTop:'none'}}>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id+1}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        style={{ maxWidth: headCell.width, paddingBottom:0, borderTop:'none', paddingTop: 0}}
                        autoFocus={headCell.id === 'ftin'}
                    >
                        <Grid container direction="column" style={{verticalAlign:'top'}}>
                            <Grid item style={{paddingLeft:'.2em',paddingRight:'.3em'}}>
                                {headCell.id === 'selectAll' ? 
                                    ''
                                :
                                    <TextField
                                        id={`filter-${headCell.id}`}
                                        style={{ width: '10rem', maxWidth: headCell.width}}
                                        autoFocus={headCell.id === 'ftin'}
                                        placeholder={headCell.filterLable}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={onFilter(headCell.id)}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

// Updated PropTypes to match actual usage
EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestFilter: PropTypes.func.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),     
    },   
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();

    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = event => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton 
                onClick={handleBackButtonClick} 
                disabled={page === 0} 
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}               
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 250,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    visuallyHidden: {
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
   
});

class ManageTINsforNNUSTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'desc',
            orderBy: 'displayDate',
            page: 0,
            rowsPerPage: 10,
            deleteDialogOpen: false,
            deleteIndex: null,
            deleteTin: ''
        };
    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({order: isDesc ? 'asc' : 'desc', orderBy: property});
    }

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage});
    }

    handleChangeRowsPerPage = event => {
        this.setState({
            page: 0, 
            rowsPerPage: parseInt(event.target.value, 10)
        });
    }

    handleRequestFilter = (value, property) => {
        if(value.length < 1) {
            this.props.setFilter(this.props.rows);
            return true;
        } else {
            this.props.setFilter(this.props.rows.filter(tin => {
                let cValue = value.toUpperCase();
                let pValue = tin[property];
                
                if("displayDate" === property) {
                    pValue = formatDate(pValue);
                }
                
                if(pValue && pValue.toUpperCase().search(cValue) !== -1) {
                    this.setState({ page: 0 });
                    return true; // Return true to keep this item
                }
                return false;
            }));
        }
    }
  
   openDeleteDialog = (tin) => {
        console.log(`Opening delete dialog for TIN ${tin.ftin}`);
        this.setState({
            deleteDialogOpen: true,
            deleteTin: tin
        });
    };

    closeDeleteDialog = () => {
        this.setState({
            deleteDialogOpen: false,
            deleteTin: null
        });
    };

    confirmDelete = () => {
        // Call the parent's deleteRow method with the TIN object
        if (this.state.deleteTin) {
            this.props.deleteRow(this.state.deleteTin);
        }
        // Close the dialog
        this.closeDeleteDialog();
    };

    render() {
        const {classes} = this.props;
        const { order, orderBy, page, rowsPerPage, deleteDialogOpen, deleteTin  } = this.state;
        const { filtered } = this.props;
        const isLastRecord = filtered.length <= 1;
        return (
            
            <div className={classes.root}>
                <Dialog
                    open={deleteDialogOpen}
                    onClose={this.closeDeleteDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to remove this TIN {deleteTin ? deleteTin.ftin : ''}?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                       
                        <Button onClick={this.confirmDelete} color="primary" autoFocus>
                            OK
                        </Button>

                         <Button onClick={this.closeDeleteDialog} color="primary">
                            CANCEL
                        </Button>
                    </DialogActions>
                </Dialog>
                <Paper className={classes.paper}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                        component="div"
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        ActionsComponent={TablePaginationActions}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                    <div className={classes.tableWrapper}>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size='small'
                            aria-label="Manage TINs table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                onRequestFilter={this.handleRequestFilter}
                                rowCount={filtered.length}
                            />
                            <TableBody>
                                {stableSort(filtered, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const labelId = `tin-table-row-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                role="row"
                                                tabIndex={-1}
                                                key={`${row.ftin}-${index}`}
                                            >
                                                <TableCell component="th" id={labelId} scope="row">
                                                    {row.ftin}
                                                </TableCell>
                                                <TableCell component="th" scope="row" style={{ width: '45%' }}>
                                                    {row.displayDate}
                                                </TableCell>
                                                <TableCell component="th" scope="row" padding="checkbox">
                                                   <Tooltip title={isLastRecord ? "Cannot delete the last record" : "Delete Row"}>
                                                        <span> {/* Wrap in span to maintain tooltip when disabled */}
                                                            <IconButton 
                                                                aria-label="delete" 
                                                                onClick={() => this.openDeleteDialog(row)}
                                                                disabled={isLastRecord} // Disable if it's the last record
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {filtered.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            No records found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}                                    
                                        count={filtered.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}                                   
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>               
                </Paper>
            </div>
        );
    }
}

ManageTINsforNNUSTable.propTypes = {
    classes: PropTypes.object.isRequired,
    rows: PropTypes.array.isRequired,
    filtered: PropTypes.array.isRequired,
    setFilter: PropTypes.func.isRequired,
    deleteRow: PropTypes.func.isRequired
};

export default withStyles(useStyles)(ManageTINsforNNUSTable);